


















import { Component, Vue } from "vue-property-decorator";
import { deleteFile } from "@/services/files/fileService";

@Component
export default class FileDeleteModal extends Vue {
    fileToBeDeleted: string = "";
    fileName: string = "";
    isSaved: boolean = false;

    handleEnter(e: KeyboardEvent) {
        if (e.key === "Enter") {
            if (this.fileToBeDeleted !== "") this.confirm();
            else this.close();
        }
    }

    removeEvent() {
        window.removeEventListener("keydown", this.handleEnter);
        this.isSaved = false;
        this.fileToBeDeleted = "";
        this.fileName = "";
    }

    open(fileId: string, name: string) {
        this.fileToBeDeleted = fileId;
        this.fileName = name;
        this.$bvModal.show("modal-deleteFile");
        window.addEventListener("keydown", this.handleEnter);
    }

    close() {
        this.$bvModal.hide("modal-deleteFileNotAllowed");
    }

    decline() {
        this.$bvModal.hide("modal-deleteFile");
        this.fileToBeDeleted = "";
        this.fileName = "";
    }

    confirm() {
        if (this.isSaved) return;
        this.isSaved = true;
        deleteFile(this.fileToBeDeleted).then(() => {
            this.$emit("fileDeleted", this.fileName);
            this.fileToBeDeleted = "";
            this.fileName = "";
            this.$bvModal.hide("modal-deleteFile");
        });
    }
}
